module.exports = __webpack_public_path__ + "img/gy.962b3bdc.svg";